import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Select, Input, Space, Popover } from 'antd';
import { HomeOutlined, SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import moment from 'moment';//日期格式化导包
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import Message from '../../component/message/message';
import UploadModal from './uploadModal';
import CloneModal from './cloneModal';
import SelectProgModal from '../../component/selectProgModal/selectProgModal';
import './wilProgrammeSetup.css';
import CohortProgModal from './cohortProgModal';
import trans from './translation';
const { Option } = Select;

const WilProgrammeSetupReport = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramSegmentList, setParamSegmentList] = useState([]);
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [isUpload, setIsUpload] = useState(false);
    const [isClone, setIsClone] = useState(false);
    const [isSearchProgModal, setIsSearchProgModal] = useState(false);
    const [searchProgModel, setSearchProgModel] = useState({});
    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    const [progId, setProgId] = useState(null);
    const [academicList, setAcademicList] = useState([]);
    const [programmeParametersId, setProgrammeParametersId] = useState(null);
    const [cohortList, setCohortList] = useState([]);
    const tableColumns = {
    }
    const [options, setOptions] = useState([]);
    const [lastUpdatedDateNew, setLastUpdatedDateNew] = useState(null);
    const [isSearch, setIsSearch] = useState([]);
    const [cohortProgramme, setCohortProgramme] = useState("");

    // const options = [
    //     { label: "Lisa Wong", value: "Lisa Wong" },
    //     { label: "Li Ka Shing", value: "Li Ka Shing" },
    // ]


    useEffect(() => {
        search(pageSize, 1, "N");
        academicSearch();
        searchCohortList()
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }
    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("programmeParameters/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        setDownloadModel(model)
        Base.callBackApi("programmeParameters/searchReportList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTables(data?.object?.list)
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false))
        // setTables([
        //     { id: 1, cohortYear: "2024", wilProgrammeCode: "COMPUTING", wilProgrammeName: "Computing", programmeLeader: "Chan Siu Ming", moduleConvener: "Chan Tai Ming", academicSupervisor: "Lisa Wong, Li Ka Shing", programmeDesc: "Testing", lastUpdateDate: new Date(), status: "Y", receiveNotification: "Y", handleStudentJobApproval: "Y" }
        // ]);
    }
    const academicSearch = () => {
        let model = {}
        Base.callBackApi("programmeParameters/academicSearch", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setAcademicList(data?.object);
                let models = []
                for (let i = 0; i < data?.object.length; i++) {
                    models[i] = {
                        value: data.object[i].userId,
                        label: data.object[i].staffName
                    }
                }
                setOptions(models)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setFlag("add");
        setTabIndex("2");
        setCohortProgModel({})
    }

    const clone = () => {
        if (!selectedRowKeys || selectedRowKeys.length === 0) {
            errFrameShow("error", "Please select at least one record.");
            return;
        }
        setIsClone(true);
    }

    const cloneClose = (flag) => {
        setIsClone(false);
    }

    const download = () => {
        setIsUpload(true)
    }

    const uploadClose = (flag) => {
        setIsUpload(false);
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            progCode: model.progCode ?? '',
            progTitle: model.progTitle ?? '',
            cohortYear: model.cohortYear ?? '',
            programmeLeader: model.programmeLeaderId ?? '',
            moduleConvener: model.moduleConvenerId ?? '',
            academicSupervisor: model.academicSupervisor,
            status: model.status ?? '',
            assignment1LogWeighting: model.assignment1LogWeighting ?? '',
            assignment2FinalReportWeighting: model.assignment2FinalReportWeighting ?? '',
            assignment3OtherWeighting: model.assignment3OtherWeighting ?? '',
            wpaWeighting: model.wpaWeighting ?? '',
            wpaQuestion1Weighting: model.wpaQuestion1Weighting ?? '',
            wpaQuestion2Weighting: model.wpaQuestion2Weighting ?? '',
            wpaQuestion3Weighting: model.wpaQuestion3Weighting ?? '',
            wpaQuestion4Weighting: model.wpaQuestion4Weighting ?? '',
            wpaQuestion5Weighting: model.wpaQuestion5Weighting ?? '',
            wpaQuestion6Weighting: model.wpaQuestion6Weighting ?? '',
            wpaQuestion7Weighting: model.wpaQuestion7Weighting ?? '',
            wpaQuestion8Weighting: model.wpaQuestion8Weighting ?? '',
            wpaQuestion9Weighting: model.wpaQuestion9Weighting ?? '',
            wpaQuestion10Weighting: model.wpaQuestion10Weighting ?? '',
            wpaQuestion11Weighting: model.wpaQuestion11Weighting ?? '',
            wpaQuestion12Weighting: model.wpaQuestion12Weighting ?? '',
            wpaQuestion13Weighting: model.wpaQuestion13Weighting ?? '',
            programmeSpecificWpaQuestion9: model.programmeSpecificWpaQuestion9 ?? '',
            programmeSpecificWpaQuestion10: model.programmeSpecificWpaQuestion10 ?? '',
            programmeSpecificWpaQuestion11: model.programmeSpecificWpaQuestion11 ?? '',
            programmeSpecificWpaQuestion12: model.programmeSpecificWpaQuestion12 ?? '',
            programmeSpecificWpaQuestion13: model.programmeSpecificWpaQuestion13 ?? '',
        });
        setCohortProgModel({})
        setCohortProgramme(model.progTitle)
    }


    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true)
        Base.callBackApi("programmeParameters/delete", paramModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, 1, "N");
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onSave = (values) => {
        messageShowHandler();
        let numbers = form.getFieldsValue()
        let sum = numbers['assignment1LogWeighting']
            + numbers['assignment2FinalReportWeighting']
            + numbers['assignment3OtherWeighting']
            + numbers['wpaWeighting']
            + numbers['wpaQuestion1Weighting']
            + numbers['wpaQuestion2Weighting']
            + numbers['wpaQuestion3Weighting']
            + numbers['wpaQuestion4Weighting']
            + numbers['wpaQuestion5Weighting']
            + numbers['wpaQuestion6Weighting']
            + numbers['wpaQuestion7Weighting']
            + numbers['wpaQuestion8Weighting']
            + numbers['wpaQuestion9Weighting']
            + numbers['wpaQuestion10Weighting']
            + numbers['wpaQuestion11Weighting']
            + numbers['wpaQuestion12Weighting']
            + numbers['wpaQuestion13Weighting']
        if (sum > 1.00) {
            errFrameShow('error', 'Assignment Weighting plus WPA Questions Weighting cannot exceed 1.')
            return
        }
        let model = {
            ...values,
            cohortProgId: progId,
            programmeParametersId: programmeParametersId
        }
        if (flag == "edit") {
            setIsLoad(true)
            Base.callBackApi("programmeParameters/update", { ...model, lastUpdatedDate: lastUpdatedDateNew }).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object)
                    setFlag("edit");
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        } else {
            setIsLoad(true)
            Base.callBackApi("programmeParameters/insert", model).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object)
                    setFlag("edit");
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
        setProgrammeParametersId(null)
    }

    const closeSearchProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
            setSearchProgModel(cohortProg);
        }
        setIsSearchProgModal(false);
    }

    const closeCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            if (isSearch) {
                setSearchModel(model => {
                    return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
                });
                setCohortProgModel(cohortProg);
            } else {
                form.setFieldsValue({
                    progId: cohortProg.progId,
                    progCode: cohortProg.progCode,
                    progTitle: cohortProg.progTitle,
                    cohortYear: cohortProg.cohortYear
                });
                setCohortProgModel(cohortProg);
                setProgId(cohortProg.cohortProgId)
                setCohortProgramme(cohortProg.progTitle)
            }
        }
        setIsCohortProgModal(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const update = (model, e) => {
        e.stopPropagation();
        setIsLoad(true);
        searchById(model.programmeParametersId)
    }

    const searchById = (programmeParametersId) => {
        setIsLoad(true);
        Base.callBackApi("programmeParameters/searchById", programmeParametersId).then((data) => {
            if ("SUCCESS" === data.msg) {
                initForm(data?.object)
                setProgId(data?.object?.cohortProgId)
                setLastUpdatedDateNew(data?.object?.lastUpdatedDate)
                setProgrammeParametersId(data?.object?.programmeParametersId)
                setFlag("edit");
                setTabIndex("2");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setParamModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("Programme Code" + ":" + model.progCode + "")
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([])
    }

    const validateRange = (value) => {
        if (parseFloat(value) > 1.00 || parseFloat(value) < 0.01) {
            return Promise.reject('Value error, Range should be between 0.01 and 1.');
        }
        return Promise.resolve();
    };

    const columns = [
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth6',
        },
        {
            title: "Department",
            dataIndex: 'deptName',
            className: 'tableWidth6',
        },
        {
            title: "Cohort",
            dataIndex: 'cohortYear',
            className: 'tableWidth3',
        },
        {
            title: "Programme Leader",
            dataIndex: 'programmeLeaderName',
            className: 'tableWidth5',
        },
        {
            title: "Module Convener",
            dataIndex: 'moduleConvenerName',
            className: 'tableWidth5',
        },
        {
            title: "Academic Supervisor",
            dataIndex: 'academicSupervisors',
            className: 'tableWidt5',
        },
        {
            title: "Assignment Weighting ",
            children: [
                {
                    title: 'Assignment-1 (Log) Weighting',
                    dataIndex: 'assignment1LogWeighting',
                    className: 'tableWidth5',
                },
                {
                    title: 'Assignment-2 (Report) Weighting ',
                    dataIndex: 'assignment2FinalReportWeighting',
                    className: 'tableWidth5',
                },
                {
                    title: 'Assignment-3 (Other) Weighting ',
                    dataIndex: 'assignment3OtherWeighting',
                    className: 'tableWidth5',
                },
                {
                    title: 'WPA Weighting',
                    dataIndex: 'wpaWeighting',
                    className: 'tableWidth4',
                },
            ],
        },
        {
            title: "Programme Specific WPA Questions",
            dataIndex: 'academicSupervisors',
            children: [
                {
                    title: 'Q9',
                    dataIndex: 'programmeSpecificWpaQuestion9',
                    className: 'tableWidth5',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className="operationLogManageContent">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q10',
                    dataIndex: 'programmeSpecificWpaQuestion10',
                    className: 'tableWidth5',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className="operationLogManageContent">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q11',
                    dataIndex: 'programmeSpecificWpaQuestion11',
                    className: 'tableWidth5',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className="operationLogManageContent">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q12',
                    dataIndex: 'programmeSpecificWpaQuestion12',
                    className: 'tableWidth5',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className="operationLogManageContent">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q13',
                    dataIndex: 'programmeSpecificWpaQuestion13',
                    className: 'tableWidth5',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className="operationLogManageContent">{text}</div>
                    </Popover>
                },
            ],
        },
        {
            title: "WPA Question Weighting ",
            dataIndex: 'academicSupervisors',
            className: 'tableWidt15',
            children: [
                {
                    title: 'Q1',
                    dataIndex: 'wpaQuestion1Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q2',
                    dataIndex: 'wpaQuestion2Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q3',
                    dataIndex: 'wpaQuestion3Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q4',
                    dataIndex: 'wpaQuestion4Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q5',
                    dataIndex: 'wpaQuestion5Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q6',
                    dataIndex: 'wpaQuestion6Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q7',
                    dataIndex: 'wpaQuestion7Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q8',
                    dataIndex: 'wpaQuestion8Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q9',
                    dataIndex: 'wpaQuestion9Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q10',
                    dataIndex: 'wpaQuestion10Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q11',
                    dataIndex: 'wpaQuestion11Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q12',
                    dataIndex: 'wpaQuestion12Weighting',
                    className: 'tableWidt2',
                },
                {
                    title: 'Q13',
                    dataIndex: 'wpaQuestion13Weighting',
                    className: 'tableWidt2',
                },
            ],
        },
    ];

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Programme Parameter Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "programmeParamters/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    return (
        <div id="container" className="template wilProgrammeSetup">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain' style={{ paddingTop: '15px' }}>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />

                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitle">Programme </div>
                            <div className="sysButtonSearchInput">
                                <Input type="text" value={searchModel.progCode || ''} disabled
                                    placeholder="Programme "
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('progCode', e.target.value)} />
                            </div>
                            <Button className="sysBtn btnBlue" onClick={() => { setIsCohortProgModal(true); setIsSearch(true) }}>Select</Button>
                            {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Programme Leader</div>
                            <div className="sysSerchInput">
                                <Select className='sysSelect'
                                    value={searchModel.programmeLeaderId || ''}
                                    onChange={(value) => searchChange('programmeLeaderId', value)}
                                >
                                    <Option></Option>
                                    {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName}</Option>)}
                                </Select>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Module Convener</div>
                            <div className="sysSerchInput">
                                <Select className='sysSelect'
                                    value={searchModel.moduleConvenerId || ''}
                                    onChange={(value) => searchChange('moduleConvenerId', value)}
                                >
                                    <Option></Option>
                                    {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName}</Option>)}
                                </Select>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Academic Supervisor</div>
                            <div className="sysSerchInput">
                                <Select className='sysSelect'
                                    value={searchModel.academicSupervisorId || ''}
                                    onChange={(value) => searchChange('academicSupervisorId', value)}
                                >
                                    <Option></Option>
                                    {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName}</Option>)}
                                </Select>

                            </div>
                        </div>
                        <div className='sysSearchButton'>
                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                        </div>
                    </div>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="buttonRelative">
                        <Button className='sysBtn btnBlue' type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canInsert === "N"} icon={<DownloadOutlined />}>Export</Button>
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            // rowSelection={rowSelection} //选择
                            rowKey="programmeParametersId"
                            scroll={{ x: 3400 }}
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>

                </Spin>
                {isUpload && <UploadModal onClose={uploadClose} />}
                {isClone && <CloneModal onClose={cloneClose} />}
                {isSearchProgModal && <SelectProgModal onClose={closeSearchProgModal} progModel={searchProgModel} />}
                {isCohortProgModal && <CohortProgModal onClose={closeCohortProgModal} progModel={cohortProgModel} />}
            </div>
        </div>
    )

}

export default WilProgrammeSetupReport;